import receptionApi from '@/api/reception';
import router from '@/router'

const state = {
    listVisitor: null,
    visitorDesktop: null,
    isLoading: false,
    validationErrors: null,
    isSubmitting: false,
    documentRemove:null
}

export const mutationTypes = {
    getVisitorListStart: '[visitor] Get visitor start',
    getVisitorListSuccess: '[visitor] Get visitor success',
    getVisitorListFailure: '[visitor] Get visitor failure',

    desktopClientStart: '[client] Desktop client start',
    desktopClientSuccess: '[client] Desktop client success',
    desktopClientFailure: '[client] Desktop client failure',

    desktopClientCardStart: '[client] Desktop client card start',
    desktopClientCardSuccess: '[client] Desktop client card success',
    desktopClientCardFailure: '[client] Desktop client card failure',

    desktopClientSaleStart: '[client] Desktop client sale start',
    desktopClientSaleSuccess: '[client] Desktop client sale success',
    desktopClientSaleFailure: '[client] Desktop client sale failure',

    documentRemoveStart: '[documentRemove] Document Remove start',
    documentRemoveSuccess: '[documentRemove] Document Remove success',
    documentRemoveFailure: '[documentRemove] Document Remove failure',
}

export const receptionActionTypes = {
    getVisitorList: '[client] Get client',
    desktopClient: '[client] Desktop client',
    desktopClientCard: '[client] Desktop client card',
    desktopClientSale: '[client] Desktop client sale',
    documentRemove: '[documentRemove] Document Remove'
}

const mutations = {
    [mutationTypes.getVisitorListStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.getVisitorListSuccess](state, payload) {
        state.isLoading = false
        state.listVisitor = payload
        state.validationErrors = null
    },
    [mutationTypes.getVisitorListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.desktopClientStart](state) {
        state.isLoading = true
        state.visitorDesktop = null
    },
    [mutationTypes.desktopClientSuccess](state, payload) {
        state.isLoading = false
        state.visitorDesktop = payload
        state.validationErrors = null
    },
    [mutationTypes.desktopClientFailure](state,payload) {
        state.isLoading = false
        state.visitorDesktop = payload
        state.validationErrors = payload
    },

    [mutationTypes.desktopClientCardStart](state) {
        state.isLoading = true
        state.visitorDesktop = null
    },
    [mutationTypes.desktopClientCardSuccess](state, payload) {
        state.isLoading = false
        state.visitorDesktop = payload
        state.validationErrors = null
    },
    [mutationTypes.desktopClientCardFailure](state,payload) {
        state.isLoading = false
        state.visitorDesktop = payload
        state.validationErrors = payload
    },

    [mutationTypes.desktopClientSaleStart](state) {
        state.isLoading = true
        state.visitorDesktop = null
    },
    [mutationTypes.desktopClientSaleSuccess](state, payload) {
        state.isLoading = false
        state.visitorDesktop = payload
        state.validationErrors = null
    },
    [mutationTypes.desktopClientSaleFailure](state,payload) {
        state.isLoading = false
        state.visitorDesktop = payload
        state.validationErrors = payload
    },

    [mutationTypes.documentRemoveStart](state) {
        state.isLoading = true
        state.documentRemove = null
    },
    [mutationTypes.documentRemoveSuccess](state, payload) {
        state.isLoading = false
        state.documentRemove = payload
        state.validationErrors = null
    },
    [mutationTypes.documentRemoveFailure](state,payload) {
        state.isLoading = false
        state.documentRemove = payload
        state.validationErrors = payload
    },

    
}

const actions = {
    [receptionActionTypes.getVisitorList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getVisitorListStart)
            receptionApi
                .getVisitorList(data)
                .then(response => {
                    context.commit(mutationTypes.getVisitorListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getVisitorListFailure,response)
                })
        })
    },
    [receptionActionTypes.desktopClient](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.desktopClientStart)
            receptionApi
                .desktopClient(data)
                .then(response => {
                    context.commit(mutationTypes.desktopClientSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    // console.log('FAILURE')
                    // alert('Клиент не найден!');
                    // router.push({ name: 'Clients', params: {} })
                    context.commit(mutationTypes.desktopClientFailure,response)
                })
        })
    },
    [receptionActionTypes.desktopClientCard](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.desktopClientCardStart)
            receptionApi
                .desktopClientCard(data)
                .then(response => {
                    context.commit(mutationTypes.desktopClientCardSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    console.log('FAILURE')
                    //alert('Клиент не найден!');
                    //router.push({ name: 'Clients', params: {} })
                    context.commit(mutationTypes.desktopClientCardFailure, response)
                })
        })
    },
    [receptionActionTypes.desktopClientSale](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.desktopClientSaleStart)
            receptionApi
                .desktopClientSale(data)
                .then(response => {
                    context.commit(mutationTypes.desktopClientSaleSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.desktopClientSaleFailure, response)
                })
        })
    },
    [receptionActionTypes.documentRemove](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.documentRemoveStart)
            receptionApi
                .documentRemove(data)
                .then(response => {
                    context.commit(mutationTypes.documentRemoveSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.documentRemoveFailure, response)
                })
        })
    },

    
}

export default {
    state,
    actions,
    mutations
}